<template>
  <a-drawer
    placement="right"
    width="500"
    :closable="false"
    @close="onClose"
    :visible="visible"
  >
    <div slot="title">
      <span>{{ edit === true? '编辑管理员' : '查看管理员' }}</span>
      <a-button v-if="!editDivVisible" style="float: right" type="primary" @click="openEditDiv">编辑</a-button>
    </div>
    <div v-if="loading" style="text-align:center"><a-spin/></div>
    <div style="margin-left:30px" v-if="!loading && !editDivVisible">
      <detail-list size="small" :col="1">
        <detail-list-item term="账号">{{ viewDetailData.account }}</detail-list-item>
        <detail-list-item term="所属角色">{{ viewDetailData.role_id | valInDict(roleDict) }}</detail-list-item>
        <detail-list-item term="联系人名称">{{ viewDetailData.nickname }}</detail-list-item>
        <detail-list-item term="联系人电话">{{ viewDetailData.phone }}</detail-list-item>
        <detail-list-item term="状态">{{ viewDetailData.status | valInDict(statusDict) }}</detail-list-item>
        <detail-list-item term="创建时间">{{ viewDetailData.create_time }}</detail-list-item>
        <detail-list-item term="备注">{{ viewDetailData.remark }}</detail-list-item>
      </detail-list>
    </div>
    <!-- 编辑div -->
    <editDiv
      v-if="editDivVisible"
      :visible="editDivVisible"
      :adminId="id"
      :adminDetail="viewDetailData"
      @hide="cancelEditDiv"
      @finish="finishEdit"/>
  </a-drawer>
</template>
<script>
import { pre, getAdminDetail } from '@/api/admin'
import _ from 'lodash'
import editDiv from './editDiv'
import DetailList from '@/components/DescriptionList'

const DetailListItem = DetailList.Item
export default {
  components: {
    DetailListItem,
    DetailList,
    editDiv
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number,
      default: 0
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      // 抽屉加载
      loading: true,
      // 编辑div状态开关
      editDivVisible: false,
      // 基本信息
      viewDetailData: {},
      // 创建人
      createNameDate: '',
      statusDict: [
        { id: 'NORMAL', name: '正常' },
        { id: 'FORBIDDEN', name: '禁用' }
      ],
      roleDict: []
    }
  },
  methods: {
    handelPre () {
      pre().then(res => {
        if (_.get(res, 'code') === 200) {
          this.roleDict = _.get(res, 'values.roleDict', [])
          this.statusDict = _.get(res, 'values.statusDict', [])
        }
      })
    },
    // 关闭抽屉
    onClose () {
      this.$emit('hide')
    },
    // 完成编辑
    finishEdit () {
      this.editDivVisible = false
      this.getDetail()
      this.$emit('finish')
    },
    // 切换编辑div
    openEditDiv () {
      this.editDivVisible = true
    },
    // 关闭编辑div
    cancelEditDiv () {
      this.editDivVisible = false
    },
    // 加载数据详情
    getDetail () {
      this.loading = true
      getAdminDetail(this.id).then(res => {
        if (_.get(res, 'code') === 200) {
          this.viewDetailData = _.get(res, 'data', {})
          this.loading = false
        }
      })
    }
  },
  created () {
    this.handelPre()
    this.getDetail()
    console.log(this.edit)
    if (this.edit === true) {
      this.editDivVisible = true
    } else {
      this.editDivVisible = false
    }
  }
}
</script>
